// xmas点击tab跳转对应模块
let currentPage = window.location.href
if(currentPage.search('/xmas-sale-2024') != -1){
  $(function(){
    let fixedTypeName = ''
    setTimeout(()=>{
        $(".AKXmasTab_fixed ul li").click(function(){
          $(this).addClass("active").siblings().removeClass("active")
          fixedTypeName = $(this).attr("data-type")
          $('html,body').animate({scrollTop:$(`#${fixedTypeName}`).offset().top-110}, 800);
      })
    },800)
  })
}

// header 菜单鼠标悬浮
$(function(){
  if(window.screen.width > 1024){
      $(".header--desktop .main-menu-dropdown .shop-1-desktop-ul li.parent:first-child").addClass("main-menu--active")
      $(".header--desktop .main-menu-dropdown li.parent").hover(function(){
        $(this).show().addClass("main-menu--active").siblings().removeClass("main-menu--active")
      })

      // header 菜单
      $(".header--desktop .main-menu .grandparent").mouseenter(function() {
        $(this).find(".main-menu-dropdown").show()
      }).mouseleave(function() {
        $(this).find(".main-menu-dropdown").hide()
      });
      $(window).scroll(function(){
  		if (window.pageYOffset >= 80) {
          $(".header--desktop .main-menu .grandparent>.main-menu-dropdown").hide();
  		}
      })
      // 菜单end
  }else{
    $(".touch__nav__links li.parent").removeClass("main-menu--active")
    $(".main-menu-dropdown li.parent").click(function(){
      $(this).find(".main-menu-child").slideToggle()
      $(this).addClass("main-menu--active").siblings().removeClass("main-menu--active")
      $(this).siblings().find(".main-menu-child").slideUp()
      $(this).siblings().find(".ariaToggle").attr("aria-expanded",false)
    })
  }
})
